module.exports = __webpack_public_path__ + "static/media/webinar-img.dc6ef7c8.jpeg";